import ModalProvider from "mui-modal-provider";
import { SnackbarProvider } from "notistack";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import BlockUI from "./components/system/block-ui/BlockUI";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import Store from "./utils/Store";

ReactDOM.render(
  <SnackbarProvider maxSnack={3}>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Store>
        <ModalProvider legacy>
          <App />
        </ModalProvider>
        <BlockUI />
      </Store>
    </BrowserRouter>
  </SnackbarProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
